
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SapInvoice } from '@/api/model';
import InvoiceStatusEnum from '@/types/invoices/InvoiceStatusEnum';

@Component
export default class InvoiceStatus extends Vue {
  @Prop(Object)
  invoice!: SapInvoice;

  get status(): string {
    if (
      Object.values(InvoiceStatusEnum).includes(
        this.invoice.AccStatusText as InvoiceStatusEnum,
      )
    ) {
      return this.$t(`invoices.status.${this.invoice.AccStatusText}`) as string;
    }
    return '-';
  }

  // BEM modifier class
  get modifier(): string {
    const days = this.invoice.DaysTillDueDate || 0;

    let modifier = '';
    switch (this.invoice.AccStatusText) {
      case InvoiceStatusEnum.BEFORE_DUE:
        modifier = days <= 7 ? 'less-than-week' : 'more-than-week';
        break;
      case InvoiceStatusEnum.DUE_DATE:
        modifier = 'less-than-week';
        break;
      case InvoiceStatusEnum.OVERDUE:
        modifier = 'overdue';
        break;
      case InvoiceStatusEnum.CLEARED:
        modifier = 'paid';
        break;
      case InvoiceStatusEnum.REVERSED:
        modifier = 'reversed';
        break;
      default:
        // All cases are covered already
        break;
    }
    return modifier ? `invoice-status--${modifier}` : '';
  }

  get showDays(): boolean {
    const { DaysTillDueDate, AccStatusText } = this.invoice;
    if (DaysTillDueDate === undefined || AccStatusText === undefined) {
      return false;
    }
    return [InvoiceStatusEnum.BEFORE_DUE, InvoiceStatusEnum.DUE_DATE].includes(
      AccStatusText as InvoiceStatusEnum,
    );
  }
}
